import * as React from "react";
import {
  CalendarIcon,
  CreditCardIcon,
  HomeIcon,
  LightbulbOutlineIcon,
  PersonOutlineIcon,
  WarningIcon,
  QuestionAnswerIcon,
} from "@origin-digital/icon";
import { logger } from "@origin-digital/reporting-client";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { routes } from "../../helpers/router.helper";
import { useAppContext } from "../../AppContext";
import { ICategory } from "../../../../shared/interface/navigation";
import quicklinksContent from "../../cms/quicklinks.json";
import { QuickLinks } from "./QuickLinks";

enum Category {
  BILLS_PAYMENTS = "BILLS_PAYMENTS",
  MY_ACCOUNT = "MY_ACCOUNT",
  NEW_ACCOUNT = "NEW_ACCOUNT",
  MOVING_OR_CLOSING = "MOVING_OR_CLOSING",
  FINANCIAL_ASSISTANCE = "FINANCIAL_ASSISTANCE",
  PRODUCTS_PLANS_PRICING = "PRODUCTS_PLANS_PRICING",
  OUTAGES_EMERGENCIES_SCAMS = "OUTAGES_EMERGENCIES_SCAMS",
  METERS_READS = "METERS_READS",
  NONE = "NONE",
}

const slugToIcon: Record<Category, JSX.Element> = {
  [Category.BILLS_PAYMENTS]: <CreditCardIcon />,
  [Category.METERS_READS]: <CalendarIcon />,
  [Category.MY_ACCOUNT]: <PersonOutlineIcon />,
  [Category.NEW_ACCOUNT]: <HomeIcon />,
  [Category.OUTAGES_EMERGENCIES_SCAMS]: <WarningIcon />,
  [Category.PRODUCTS_PLANS_PRICING]: <LightbulbOutlineIcon />,
  [Category.FINANCIAL_ASSISTANCE]: <SupervisorAccountIcon color="secondary" />,
  [Category.MOVING_OR_CLOSING]: <LocalShippingIcon color="secondary" />,
  [Category.NONE]: <QuestionAnswerIcon />,
};

const categoryIcon = (category: ICategory): React.ReactNode => {
  const categoryKey =
    Object.keys(quicklinksContent).find(
      (key) => quicklinksContent[key] === category.name
    ) || "NONE";

  const icon = slugToIcon[categoryKey];

  if (Category[categoryKey] === Category.NONE) {
    logger.error(
      `QuickLinksController: Failed to find icon for ${category.name}`
    );
  }

  return icon;
};

export const QuickLinksController = () => {
  const { navigation } = useAppContext();
  const categories =
    navigation.data && navigation.data.categories
      ? navigation.data.categories
      : [];
  const links = categories.map((category: ICategory) => ({
    title: category.displayName,
    icon: categoryIcon(category),
    link: routes.category(category.name),
  }));
  return navigation.data ? <QuickLinks quickLinks={links} /> : null;
};
